export default {
  path: '/ratio-goods',
  meta: {
    title: '商城',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/ratio-goods`),
}



// WEBPACK FOOTER //
// ./src/views/RatioGoods/router.js